import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import AdRevenueQuery from '../components/AdRevenueQuery.vue'
import FullReportManagement from '../components/FullReportManagement.vue'
import SystemConfigManagement from '../components/SystemConfigManagement.vue'
import AppInfoManagement from '../components/AppInfoManagement.vue'
import DataDashboard from '../components/DataDashboard.vue'
import UserManagement from '../components/UserManagement.vue'  // 用户管理组件导入
import UserWithdrawalManagement from '../components/UserWithdrawalManagement.vue'  // 用户提现管理组件导入
import AdminManagement from '../components/AdminManagement.vue'  // 管理员管理组件导入
import GoodsManagement from '../components/GoodsManagement.vue'  // 自营商城-商品管理
import GoodsCategoryManagement from '../components/GoodsCategoryManagement.vue'  // 分类管理
import ExternalMallManagement from '../components/ExternalMallManagement.vue'  // 外链商城-商品管理

import RiskManagement from '../components/RiskManagement.vue'  // 风控管理
import UserManagement2 from '../components/UserManagement2.vue'  // 用户分佣比例管理（隐藏页面）
import ExchangeOrderManagement from '../components/ExchangeOrderManagement.vue'  // 兑换订单管理
import CoinFlowManagement from '../components/CoinFlowManagement.vue'  // 金币明细
import AdPoolSettlementManagement from '../components/AdPoolSettlementManagement.vue'  // 副广池结算流水
import AgentDailyRevenue from '../components/AgentDailyRevenue.vue'  // 团长每日收益
import AgentCommissionWithdrawal from '../components/AgentCommissionWithdrawal.vue'  // 团长佣金提现
import AgentWithdrawalAudit from '../components/AgentWithdrawalAudit.vue'  // 超管-团长提现审核
import AlipayCallback from '../components/AlipayCallback.vue'  // 支付宝网页授权回调

// 忽略重复导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Vue.use(Router)

const router = new Router({
  mode: 'history', // 添加这一行以启用history模式
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/data-dashboard',
      name: 'DataDashboard',
      component: DataDashboard
    },
    {
      path: '/main',
      component: MainLayout,
      children: [
        {
          path: '',
          redirect: '/ad-revenue'
        },
        {
          path: '/ad-revenue',
          name: 'AdRevenueQuery',
          component: AdRevenueQuery
        },
        {
          path: '/full-report',
          name: 'FullReportManagement',
          component: FullReportManagement,
          meta: {
            title: '报表管理'
          }
        },
        {
          path: '/system/config',
          name: 'SystemConfigManagement',
          component: SystemConfigManagement
        },
        {
          path: '/system/app',
          name: 'AppInfoManagement',
          component: AppInfoManagement
        },
        {
          path: '/user-management',
          name: 'UserManagement',
          component: UserManagement
        },
        {
          path: '/user-withdrawal',
          name: 'UserWithdrawalManagement',
          component: UserWithdrawalManagement
        },
        {
          path: '/admin-management',
          name: 'AdminManagement',
          component: AdminManagement
        },
        {
          path: '/mall/goods',
          name: 'GoodsManagement',
          component: GoodsManagement,
          meta: {
            title: '自营商品管理'
          }
        },
        {
          path: '/mall/external-goods',
          name: 'ExternalMallManagement',
          component: ExternalMallManagement,
          meta: {
            title: '外链商品管理'
          }
        },
        {
          path: '/mall/categories',
          name: 'GoodsCategoryManagement',
          component: GoodsCategoryManagement,
          meta: {
            title: '分类管理'
          }
        },

        {
          path: '/mall/exchange-order',
          name: 'ExchangeOrderManagement',
          component: ExchangeOrderManagement,
          meta: {
            title: '兑换订单管理'
          }
        },
        {
          path: '/risk-management',
          name: 'RiskManagement',
          component: RiskManagement,
          meta: {
            title: '风控管理'
          }
        },
        {
          path: '/user-management2',
          name: 'UserManagement2',
          component: UserManagement2,
          meta: {
            title: '用户分佣比例管理'
          }
        },
        {
          path: '/coin-flow',
          name: 'CoinFlowManagement',
          component: CoinFlowManagement,
          meta: {
            title: '金币明细'
          }
        },
        {
          path: '/ad-pool-settlement',
          name: 'AdPoolSettlementManagement',
          component: AdPoolSettlementManagement,
          meta: {
            title: '副广池结算'
          }
        },
        {
          path: '/agent-daily-revenue',
          name: 'AgentDailyRevenue',
          component: AgentDailyRevenue,
          meta: {
            title: '团长收益'
          }
        },
        {
          path: '/agent-commission-withdrawal',
          name: 'AgentCommissionWithdrawal',
          component: AgentCommissionWithdrawal,
          meta: {
            title: '佣金提现'
          }
        },
        {
          path: '/agent-withdrawal-audit',
          name: 'AgentWithdrawalAudit',
          component: AgentWithdrawalAudit,
          meta: {
            title: '团长提现审核'
          }
        },
        {
          path: '/alipay-callback',
          name: 'AlipayCallback',
          component: AlipayCallback,
          meta: {
            title: '支付宝授权'
          }
        }
      ]
    }
  ]
})

// 需要超级管理员(role=0)权限的路由
const superAdminOnlyRoutes = [
  '/data-dashboard',
  '/system/config',
  '/system/app',
  '/admin-management',
  '/risk-management',
  '/user-management2',
  '/mall/goods',
  '/mall/external-goods',
  '/mall/categories',
  '/mall/exchange-order',
  '/coin-flow',
  '/agent-withdrawal-audit'
]

// 仅团长可访问
const agentOnlyRoutes = [
  '/agent-commission-withdrawal',
  '/agent-daily-revenue',
  '/alipay-callback'
]

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const role = parseInt(localStorage.getItem('role')) || 0

  if (to.path === '/login') {
    // 如果去的是登录页，且已经有 token，直接跳转到主页
    if (token) {
      next('/ad-revenue')
    } else {
      next()
    }
  } else if (to.path === '/') {
    // 访问根路径时，根据是否有 token 决定去向
    if (token) {
      next('/ad-revenue')
    } else {
      next('/login')
    }
  } else {
    // 如果去的是受保护路由，检查是否有 token
    if (token) {
      // 检查是否在团长用户(route=1或2)路由上尝试访问超级管理员页面
      if ((role === 1 || role === 2) && superAdminOnlyRoutes.some(path => to.path.startsWith(path))) {
        // 团长尝试访问超级管理员页面，重定向到广告收入页
        next('/ad-revenue')
      } else if (role === 0 && agentOnlyRoutes.some(path => to.path.startsWith(path))) {
        next('/ad-revenue')
      } else {
        next()
      }
    } else {
      // 没有 token，跳转到登录页
      next('/login')
    }
  }
})

export default router